<template>
  <div class="main m-0 p-0" ref="containerRef">
    <div class="p-0 h-100">
      <Carousel
        ref="myCarousel"
        class="w-100 p-0 h-100 m-0 position-relative top-0"
        id="car"
        v-model="slideIndex"
        :autoplay="5000"
      >
        <Slide class="p-0 slide position-relative h-100">
          <div class="pt-5 w-100 h-100">
            <p
              class="text-center mt-5 slide1-text"
              v-html="t('PAYJOY_CARD_VIEWS.CARD_OVERVIEW.USE_FUNDS')"
              style="font-size: 20px"
            ></p>
            <div class="start-0 end-0 w-100 mt-5">
              <img
                :src="useAsset('img/credit-line/credit-card/yourFunds.png')"
                alt="your funds"
                class="mx-auto h-100 w-100"
              />
            </div>
            <p
              class="text-center mt-5 slide1-text"
              v-html="t('PAYJOY_CARD_VIEWS.CARD_OVERVIEW.USE_VIRTUAL_CARD')"
              style="font-size: 16px; color: #595a5a"
            ></p>
          </div>
        </Slide>
        <Slide class="p-0 slide position-relative h-100">
          <div class="pt-5 w-100 ci-green-bg h-100">
            <p
              class="text-white fw-bold mt-5 slide2-text"
              v-html="t('PAYJOY_CARD_VIEWS.CARD_OVERVIEW.ORDER_TIME')"
              style="font-size: 20px"
            ></p>
            <div class="bullets-wrapper">
              <div class="bullets mt-2">
                <img
                  :src="
                    useAsset('img/credit-line/credit-card/delivery-bullet.png')
                  "
                  alt="delivery bullet"
                  class="bullet-image me-2"
                />
                <span
                  class="bullet-text"
                  v-html="
                    t('PAYJOY_CARD_VIEWS.CARD_OVERVIEW.BENEFITS_BULLET_1')
                  "
                ></span>
              </div>
              <div class="bullets">
                <img
                  :src="useAsset('img/credit-line/credit-card/mastercard.png')"
                  alt="mastercard bullet"
                  class="bullet-image me-2"
                />
                <span
                  class="bullet-text"
                  v-html="
                    t('PAYJOY_CARD_VIEWS.CARD_OVERVIEW.BENEFITS_BULLET_2')
                  "
                ></span>
              </div>
            </div>
            <div class="mt-5 mb-0 w-100">
              <img
                :src="useAsset('img/credit-line/credit-card/orderPJCard.png')"
                alt="order PJ card"
                class="mx-auto w-75 mt-2 mb-0"
              />
            </div>
          </div>
        </Slide>
        <Slide class="mt-1 slide position-relative h-100">
          <div class="pt-5 w-100 h-100">
            <p
              class="text-center w-100 mt-5 slide3-text"
              v-html="t('PAYJOY_CARD_VIEWS.CARD_OVERVIEW.TYPES_OF_WITHDRAW')"
              style="font-size: 20px"
            ></p>
            <div class="w-100 mt-auto mb-0">
              <img
                :src="setThirdSlideImage()"
                alt="merchants"
                class="mx-auto w-75"
              />
            </div>
            <p
              class="text-center slide1-text mt-3"
              v-html="t('PAYJOY_CARD_VIEWS.CARD_OVERVIEW.SERVICES')"
              style="font-size: 16px; color: #595a5a"
            ></p>
            <p
              class="text-left"
              v-html="t('PAYJOY_CARD_VIEWS.CARD_OVERVIEW.TERMS_AND_CONDITIONS')"
              style="
                font-size: 9px;
                color: #595a5a;
                width: 90%;
                margin-left: auto;
                margin-right: auto;
                margin-top: 4rem;
              "
            ></p>
          </div>
        </Slide>

        <template #addons="{ currentSlide }">
          <section
            class="position-absolute top-0 w-100 d-flex flex-row shadow-none"
          >
            <div class="mt-4 w-100 d-flex flex-row align-items-center">
              <div id="dots" class="position-relative mx-auto">
                <span
                  v-for="index in [0, 1, 2]"
                  :class="[
                    index === currentSlide
                      ? currentSlide === 1
                        ? 'active-dot contrasted-item'
                        : 'active-dot'
                      : 'dot',
                  ]"
                  :key="index"
                  @click="switchSlide(index)"
                ></span>
              </div>
              <div class="position-absolute end-0">
                <div class="upper-close px-3 pt-1">
                  <i
                    class="fa fa-times close-button"
                    :class="{ 'text-white': greenBackground }"
                    @click="
                      $router.replace({
                        name: 'CreditCardView',
                      })
                    "
                    id="dismiss-modal"
                  ></i>
                </div>
              </div>
            </div>
          </section>
          <Button
            id="redirect-btn"
            class="position-absolute"
            @click="redirect"
            :greenBackground="greenBackground"
          >
            <span class="d-flex align-items-center justify-content-center">
              <img
                :src="cardImageButton"
                alt="pc svg"
                style="width: 24px; height: 24px"
                class="me-2"
              />
              {{ buttonText }}
            </span>
          </Button>
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, computed } from "vue";
import { resizeComponentHelper } from "@/apps/credit-line/helpers/resizeComponent.helper";
import { Carousel, Slide } from "vue3-carousel";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { useRouter, useRoute } from "vue-router";
import {
  AvailableFeatures,
  FeatureControlService,
} from "@/apps/credit-line/services/feature-control.service";
import Button from "@/apps/credit-line/components/Button.vue";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";

declare const Android: AndroidInterface;

const containerRef = ref<HTMLElement | null>(null);
const myCarousel = ref();
const { t } = useI18n();
const slideIndex = ref(0);
const router = useRouter();
const route = useRoute();
const SLIDES_LENGTH = 3;
const clientEligible = ref<string>("");
const buttonText = ref<string>("");
const featureService = new FeatureControlService();
const country = ref<string>("");

const cardImageButton = computed(() => {
  if (slideIndex.value === 1) {
    return useAsset("img/credit-line/credit-card/credit_card_green.png");
  } else {
    return useAsset("img/credit-line/credit_card_white.svg");
  }
});

const greenBackground = computed(() => {
  if (slideIndex.value === 1) {
    return true;
  }
  return false;
});

const hideNav = () => {
  if (Android && typeof Android?.hideNav === "function") {
    Android.hideNav();
  }
};

const obtainButtonText = () => {
  buttonText.value =
    clientEligible.value === "true"
      ? t("PAYJOY_CARD_VIEWS.CARD_OVERVIEW.CLIENT_ELIGIBLE_BUTTON")
      : t("PAYJOY_CARD_VIEWS.CARD_OVERVIEW.CLIENT_NOT_ELIGIBLE_BUTTON");
};

const redirect = () => {
  if (clientEligible.value === "true") {
    router.push({
      name: "CreditCardShippingAddressView",
      query: {
        firstName: route.query?.firstName,
        lastName: route.query?.lastName,
        idNumber: route.query?.idNumber,
        gender: route.query?.gender,
        birthDate: route.query?.birthDate,
        email: route.query?.email,
        creditLineId: route.query?.creditLineId,
      },
    });
  } else {
    const wpNumber = featureService.getFeatureValue(
      AvailableFeatures.WHATSAPP,
      route.query?.country as string,
      "number"
    );
    window.open(`https://wa.me/${wpNumber}`, "_system");
  }
};

const setThirdSlideImage = () => {
  if (country.value === "MX") {
    return useAsset("img/credit-line/credit-card/merchants-mx.png");
  } else {
    return useAsset("img/credit-line/credit-card/merchants-co.png");
  }
};

const switchSlide = (newIndex: number) => {
  if (newIndex <= SLIDES_LENGTH) {
    myCarousel?.value?.slideTo(newIndex);
    slideIndex.value = newIndex;
  }
};

setInterval(() => {
  let x = document.getElementsByClassName("carousel__track")[0] as HTMLElement;
  let y = document.getElementsByClassName(
    "carousel__viewport"
  )[0] as HTMLElement;
  let main = document.getElementsByClassName("main")[0] as HTMLElement;
  if (x && y && main) {
    x.style.height = y.clientHeight + "px";
    y.style.height = main.clientHeight + "px";
  }
  if (x) {
    x.style.marginBottom = "0";
  }
}, 500);

onMounted(() => {
  resizeComponentHelper(containerRef);
  window.addEventListener("resize", () => resizeComponentHelper(containerRef));
  hideNav();
  document.querySelectorAll(".slide > div:first-child")?.forEach((slide) => {
    slide.style.height = window.innerHeight + "px";
  });

  clientEligible.value =
    typeof route.query?.clientEligible === "string"
      ? route.query.clientEligible
      : "";

  obtainButtonText();

  country.value = route.query?.country as string;

  myCarousel?.value?.slideTo(0);
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.slide {
  width: 100%;
}

html,
body * {
  font-family: Inter;
}

.main {
  min-height: 100vh;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.bullets-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.bullets {
  display: flex;
  align-items: flex-start;
  margin-top: 1rem;
  color: $pj-color-white;
  margin-left: 72px;
}

.bullet-text {
  flex: 1 1 0%;
  min-width: 0;
  text-align: left;
}

.bullet-image {
  flex-shrink: 0;
  width: 32px;
  margin-right: 12px;
  display: block;
}

.bullets span {
  display: block;
  word-break: break-word;
}

#application-btn {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  border: none;
  bottom: 3%;
  text-align: center;
  width: 90%;
  border-radius: 10px !important;
  background: #336417;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.32);
}

.slide3-text {
  margin-left: 42px;
  margin-right: 42px;
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: break-word;
  text-align: center;
  max-width: calc(100% - 84px);
  box-sizing: border-box;
  color: #2c7040;
}

.slide2-text {
  margin-left: auto;
  margin-right: auto;
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: break-word;
  text-align: center;
  max-width: calc(100% - 84px);
  box-sizing: border-box;
}

.slide1-text {
  color: #2c7040;
  margin-left: 52px;
  margin-right: 52px;
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: break-word;
  max-width: calc(100% - 84px);
  box-sizing: border-box;
}

.ci-green-bg {
  background: #2c7040;
}

#dots {
  margin-left: auto;
  margin-right: auto;
  top: 18%;
  width: 85%;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  overflow: visible;
  position: relative;
}

.dot {
  height: 10px;
  width: 10px;
  border-radius: 100px;
  background: rgba(17, 17, 17, 0.16);
  display: inline-block;
  margin-left: 2.5%;
}

.contrasted-item {
  background-color: white !important;
}

.white-item {
  color: white !important;
}

.active-dot {
  height: 10px;
  width: 20px;
  border-radius: 100px;
  background: $pj-color-green;
  display: inline-block;
  margin-left: 2.5%;
  transition: width 0.3s ease-out;
}

#redirect-btn {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 5%;
  height: 56px;
  padding: 10px 24px;
  font-size: medium;
  border-radius: 10px;
  font-weight: 800;
  font-style: normal;
  line-height: 20px;
  letter-spacing: -0.2px;
  width: 90%;
  border: none;
  animation: bounce-in-right 0.4s ease;
}

.carousel__viewport,
.carousel__track {
  height: 100% !important;
  min-height: 100vh;
}

.close-button {
  color: $pj-color-black;
  font-size: 25px;
  z-index: 10000;
  font-family: "Font Awesome 5 Free" !important;
}

@keyframes bounce-in-right {
  0% {
    opacity: 0;
    transform: translateY(2000px);
  }
  40% {
    opacity: 1;
    transform: translateY(-30px);
  }
  80% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
